import React from "react";
import { Divider, Typography } from "antd";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useLoader } from "../../../../Context/LoaderContext/LoaderContext";
import useAiAssessmentQuestionNavigation from "../../hooks/useAiAssessmentQuestionNavigation";
import useAiAssessmentEvaluate from "../../hooks/useAiAssessmentEvaluate";

const AiAssessmentEvaluate: React.FC = () => {
  const { aiAssessmentQuestions, isEvaluating } = useAIAssessmentContext();
  const { handleEvaluation } = useAiAssessmentEvaluate();
  const { isLoading } = useLoader();

  const answeredQuestionCount = aiAssessmentQuestions.filter(
    (question) => question.answer,
  ).length;
  const totalQuestionCount = aiAssessmentQuestions.length;
  const isAnyOneQuestionAnswered = answeredQuestionCount > 0;

  const { navigateToPreviousQuestion } = useAiAssessmentQuestionNavigation();

  const handleEvaluationClick = async () => {
    await handleEvaluation("user");
  };

  return (
    <div className="ai-assessment-evaluate-container">
      <Typography.Title level={4}>
        Are you ready to evaluate your answers ?
      </Typography.Title>

      <div className="ai-assessment-evaluate-answered-container">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={navigateToPreviousQuestion}
          style={{ cursor: "pointer" }}
        />
        <Typography.Title level={5} style={{ margin: 0 }}>
          {`Answered: ${answeredQuestionCount
            .toString()
            .padStart(2, "0")} / ${totalQuestionCount
            .toString()
            .padStart(2, "0")}`}
        </Typography.Title>
        <Button
          type="text"
          icon={<ArrowRightOutlined />}
          style={{ cursor: "pointer" }}
          disabled
        />
      </div>

      <Typography.Paragraph style={{ textAlign: "center" }}>
        Please ensure all the questions are answered and submit for evaluation.
      </Typography.Paragraph>

      <Divider style={{ margin: "0px" }} />

      {!isEvaluating && (
        <Button
          type="primary"
          onClick={handleEvaluationClick}
          disabled={!isAnyOneQuestionAnswered}
          loading={isLoading}
        >
          Evaluate Response
        </Button>
      )}
    </div>
  );
};

export default AiAssessmentEvaluate;
